<template>
  <div class="wallet-page">
    <div class="breadcrumb-wrap">
      <h2>Aleo Mining</h2>
      <ul class="breadcrumb">
        <li>
          <router-link :to="{name: 'Home'}"><i class="bx bxs-home"></i>Home</router-link>
        </li>
        <li>
          <router-link :to="{name: 'Dashboard'}"><i class="bx bxs-dashboard"></i>Dashboard</router-link>
        </li>
        <li>
          <span>Aleo Mining</span>
        </li>
      </ul>
    </div>
    <div class="buy-package-wrap" :class="{ 'loading': isProcessing }">
      <div class="flex-box">
        <div class="quick-buy">
          <div class="field">
            <div class="field-label">
              <span>Quick buy(USDT)</span>
            </div>
            <div class="items">
              <div class="item" v-for="(item, index) in quickBuyList" :key="index"  @click="quickBuy(item.usd)">
                <div class="item-head">
                  <img src="/assets/images/icons/usdt.png" alt="">${{item.usd}}
                </div>
                <div class="item-body">
                  <p>{{item.ppst}} {{base}}</p>
                  <p>{{item.pps}} {{quote}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <form class="fields">
          <div class="title">
            <h2>Buy Manual</h2>
          </div>
          <div class="fields-wrap">
            <div class="field">
              <div class="field-label">Buy Amount (USDT)</div>
              <div class="field-input">
                <el-input placholder="Amount" v-model="form.amount"></el-input>
              </div>
              <div class="field-tip">
                <ul>
                  <li><em>USDT Balance: </em><strong>{{ usdtBalance.balance }} USDT</strong></li>
                  <li><em>Discount Amount: </em><strong>1 {{base}} = {{ userConfig.pricePpstUsd }} USDT</strong></li>
                  <li><em>Minimum investment: </em><strong>{{ userConfig.minBuyPpst}} {{base}}</strong></li>
                  <li><strong>1 {{quote}} = {{ userConfig.pricePpsPpst }} {{base}}</strong></li>
                </ul>
              </div>
            </div>
            <div class="field">
              <div class="field-label">{{base}}</div>
              <div class="field-input">
                <el-input placholder="PPST Amount" disabled v-model="estimateForm.ppst"></el-input>
              </div>
            </div>
            <div class="field" v-if="estimateForm.bonusPpst > 0">
              <div class="field-label">Bonus {{ base }}</div>
              <div class="field-input">
                <el-input placholder="PPST Amount" disabled v-model="estimateForm.bonusPpst"></el-input>
              </div>
            </div>
            <div class="field">
              <button class="el-button el-button--default" :class="{ 'disabled': !isValidated }" type="button" @click="buyIeo"><span>Purchase</span></button>
            </div>
            <div class="field node-info-wrapper">
              <a class="node-info" href="https://www.aleo123.io/address/aleo177zvr6mx6tsrwmhxjh03clvg8nu604z9dh853v4szg2t2x3fygyss4f8p6" target="_blank">
                <span>ALEO Mining RRG Node 1</span>
                <img src="/assets/images/nodes/aleo123.png" alt="ALEO Mining RRG Node 1">
              </a>
            </div>
            <div class="field node-info-wrapper">
              <a class="node-info" href="https://www.damominer.hk/miner/aleo177zvr6mx6tsrwmhxjh03clvg8nu604z9dh853v4szg2t2x3fygyss4f8p6" target="_blank">
                <span>ALEO Mining RRG Node 2</span>
                <img src="/assets/images/nodes/damo-miner.png" alt="ALEO Mining RRG Node 2">
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="history-section" id="buy-history">
      <div class="table-box">
        <div class="title">
          <h2>History</h2>
        </div>
        <div class="table-fixed-wrap">
          <div class="table-box-inner">
            <dl class="table-medium">
              <dt>
                <div class="item-no">{{ $t('TEXT_NO') }}.</div>
                <div class="width-1_5x">Token Mining</div>
                <div class="width-1_5x">{{ $t('TEXT_AMOUNT_USD') }}</div>
                <div class="width-1_5x">{{ $t('TEXT_PRICE') }}</div>
                <div class="width-1_5x">Power Minting</div>
                <div class="width-1_5x">Token Bonus</div>
                <div class="width-1_5x" title="Power Minting Bonus">Power Minting Bonus</div>
                <div class="flex-2">{{ $t('TEXT_DATE') }}</div>
              </dt>
              <dd v-for="(pack, index) in transactionHistory" :key="pack.id" :class="{'cross-line': pack.percentConverted  === 100}">
                <div class="item-no">{{ index + 1 }}</div>
                <div class="width-1_5x">
                  {{ pack.tokenMining }}
                  <el-tooltip class="item" effect="dark" content="Convert PPTS to Gh/s" placement="right-start">
                    <img :src="pack.percentConverted === 100 ? '/assets/images/icons/converted-done.png': '/assets/images/icons/convert-icon.png'"
                         class="icon-convert" title="Convert PPTS to Gh/s"
                         @click="openConvertForm(pack)">
                  </el-tooltip>
                </div>
                <div class="width-1_5x">{{ pack.beautyAmountUsd }}</div>
                <div class="width-1_5x">{{ pack.beautyPrice }}</div>
                <div class="width-1_5x">{{ pack.beautyAmountPps }}</div>
                <div class="width-1_5x">{{ pack.tokenBonus ? (`${pack.beautyBonusIron} (${pack.symbolBonus})`) : pack.beautyBonusIron }}</div>
                <div class="width-1_5x">{{ pack.beautyBonusPps }}</div>
                <div class="flex-2">{{ pack.beautyCreatedAt }}</div>
              </dd>
              <dd v-if="!pagination.totalPage" class="no-data-wrap">
                <div class="no-data">{{ $t('TEXT_NO_DATA') }}</div>
              </dd>
            </dl>
            <el-pagination
              v-if="pagination.totalPage"
              :current-page="pagination.currentPage"
              :page-count="pagination.totalPage"
              background
              layout="prev, pager, next"
              @current-change="goToPage"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UtilService from '@/utils/UtilService'
import BigNumber from 'bignumber.js'
import _ from 'lodash'
export default {
  data () {
    return {
      isProcessing: false,
      base: 'PPST',
      quote: 'PPS',
      form: {
        amount: '',
        symbol: 'ALEO'
      },
      estimateForm: {
        ppst: 0,
        pps: 0,
        bonusPpst: 0,
        bonusPps: 0,
        bonusIron: 0
      },
      isLoadingHistory: false
    }
  },
  computed: {
    usdtBalance () {
      if (!this.balances || !this.balances.length) return {}
      return this.balances.filter(temp => temp.currency === 'USDT')[0]
    },
    balances () {
      return this.$store.getters.balances
    },
    isValidated () {
      return this.form.amount && !isNaN(this.form.amount) && parseFloat(this.form.amount) > 0 &&
        this.userConfig.is_allow_buy &&
        UtilService.isInteger(this.form.amount) &&
        new BigNumber(this.form.amount).comparedTo(this.userConfig.min_buy) !== -1 &&
        new BigNumber(this.form.amount).comparedTo(this.userConfig.max_buy) !== 1 &&
        new BigNumber(this.form.amount).comparedTo(this.usdtBalance.balance) !== 1
    },
    isBalanceNotEnough () {
      return this.form.amount &&
        (new BigNumber(this.form.amount).comparedTo(this.maxAmountUsd) === 1 ||
        new BigNumber(this.form.amount).comparedTo(this.selectedBalance.balanceUsdt) === 1)
    },
    isBalanceIsNotValid () {
      return this.form.amount &&
        (isNaN(this.form.amount) || new BigNumber(this.form.amount).comparedTo(this.minAmountUsd) !== 1)
    },
    transactionHistory () {
      return this.$store.getters.transactionHistory
    },
    pagination () {
      return this.$store.getters.pagination
    },
    userConfig () {
      return this.$store.getters.userConfig
    },
    user () {
      return this.$store.getters.user
    },
    configs () {
      return this.$store.getters.configs
    },
    quickBuyList () {
      return this.userConfig.quickBuys
    }
  },
  watch: {
    'form.amount': _.debounce(function () {
      this.form.amount && this.getEstimateBuy()
    }, 600)
  },
  async created () {
    this.isProcessing = true
    await this.$store.dispatch('getUserConfig', this.form.symbol)
    this.$store.dispatch('getBalances').then(rs => {})
    this.fetch()
    setTimeout(() => {
      this.isProcessing = false
    }, 500)
  },
  methods: {
    async getEstimateBuy () {
      try {
        this.isProcessing = true
        const res = await this.$store.dispatch('getEstimateBuy', this.form)
        res.status && (this.estimateForm = res.data)
        await UtilService.sleep(1000)
        this.isProcessing = false
      } catch (error) {
        this.isProcessing = false
      }
    },
    quickBuy (amount) {
      this.form.amount = amount
      this.buyIeo()
    },
    async buyIeo () {
      if (!this.isValidated) {
        this.$store.dispatch('showErrorMsg', 'Not enough balance')
        return
      }
      await this.getEstimateBuy()
      const textConfirm = `<h4>Final Commitment Agreement between Company and Customer</h4>
        <div class="notification-buy-content">
          <p>The company RRG Mining LTD and the customer <strong>${this.user.username}</strong> hereby confirm and commit to the following:</p>
          <ol>
            <li>
              ALEO's Mining hashrate rental service:
              <ul>
                <li>Hashrate package: <strong>${this.estimateForm.pps}${this.quote}/ ${this.estimateForm.ppst}${this.base}</strong>.</li>
                <li>Mining Output: <strong>${this.estimateForm.percentReceive * 100}% tokens</strong></li>
                <li>Payment period: <strong>1100 days</strong> from</li>
                <li>The Aleo's first mainnet day or the 10th days since purchase time</li>
                ${(this.estimateForm.bonusPpst > 0 ? '<li>Bonus ' + this.base + ': <strong>' + this.estimateForm.bonusPpst + ' Gh/s</strong></li>' : '')}
                ${(this.estimateForm.bonusTokenAmount > 0 ? '<li>Bonus ' + this.estimateForm.bonusTokenSymbol + ': <strong>' + this.estimateForm.bonusTokenAmount + ' ' + this.estimateForm.bonusTokenSymbol + '</strong></li>' : '')}
              </ul>
            </li>
            <li>
              Price
              <ul>
                <li>Price of the package is: <strong>$${this.form.amount}</strong></li>
              </ul>
            </li>
            <li>
              Customer's Commitment:
              <ul>
                <li>The customer agrees to voluntarily purchase the Aleo's mining hashrate rental service from RRG Mining, without any coercion</li>
                <li>The service package is non-cancellable and non-refundable.</li>
              </ul>
            </li>
          </ol>
          <br>
          <p>By clicking the <strong>"Confirm"</strong> button, you acknowledge and confirm the terms and commitments stated above.</p>
        </div>
        `
      const body = {
        amount: this.form.amount,
        symbol: this.form.symbol
      }
      this.$confirm(textConfirm, 'Confirm', {
        confirmButtonText: 'Confirm',
        dangerouslyUseHTMLString: true,
        iconClass: 'no-icon',
        customClass: 'buy-confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isProcessing = true
        this.$store.dispatch('buyPackage', body).then(rs => {
          this.isProcessing = false
          if (rs) {
            this.fetch()
            this.$store.dispatch('getBalances').then(rs => {})
            this.form.amount = ''
            this.estimateForm = {
              ppst: 0,
              pps: 0,
              bonusPpst: 0,
              bonusPps: 0,
              bonusIron: 0
            }
          }
        })
      }).catch(() => {
      })
    },
    min () {
      this.form.amount = this.userConfig.min_buy
    },
    max () {
      this.form.amount = this.userConfig.max_buy
    },
    fetch () {
      this.$store.dispatch('getTransHistory', { page: this.pagination.page, params: { symbol: this.form.symbol } })
    },
    goToPage (page) {
      const temp = JSON.parse(JSON.stringify(this.pagination))
      temp.page = page
      this.$store.dispatch('setPagination', temp)
      this.fetch()
    },
    openConvertForm (pack) {
      this.$store.dispatch('setCurrentConvertItem', pack)
      this.$store.dispatch('toggleConvertPpsToGh', true)
    }
  }
}
</script>
